import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { useHorses } from '../../hooks/useHorses'
import { debounce, get } from 'lodash'
import { Autocomplete, TextField } from '@mui/material'
import { t } from 'i18next'
import { TTrainerHorse } from '../../shared/types/trainerHorse.type'

function AutocompleteHorse({ handleChangedValue }: {  handleChangedValue: (value: TTrainerHorse | null) => void }) {
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
    const [search, setSearch] = useState('')

    const { horses, isLoadingHorses } = useHorses(!isUserLoading || false, get(auth, '@id'), {
        horses: {
            pagination: true,
            page: 1,
            itemsPerPage: 30,
            'include-total-count': true,
            ...(search ? { 'horse.name': search } : {})
        }
    })

    const debouncedSearch = debounce((value: string) => {
        setSearch(value)
    }, 500)


    return (
        <Autocomplete
            disablePortal
            fullWidth
            onInputChange={(_, value) => debouncedSearch(value)}
            options={horses}
            getOptionLabel={horse => horse.horse?.name ?? ""}
            loading={isLoadingHorses}
            getOptionKey={horse => horse.horse?.['@id'] ?? ""}
            onChange={(_, value) => handleChangedValue(value)}
            renderInput={(params) => <TextField {...params} label={t('timeline:filterByHorse')} />}
        />
    )
}

export default AutocompleteHorse